import apiempresaweb from '@/services/api-recebimentoweb';

export default {
  namespaced: true,

  state: {
    list: [],
    prevenda: {},
    valorTotal: 0,
  },

  getters: {
    list: (state) => state.list,
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {
    async find(_, {
      where, ...params
    } = {}) {
      const [{ data }] = await Promise.all([
        apiempresaweb.get('prevenda', { params: { ...where, ...params } }),
      ]);

      return data;
    },

    async findDetalhado(_, { idVendedor, food }) {
      const [{ data }] = await Promise.all([
        apiempresaweb.get(`prevenda/detalhado/${idVendedor}/${food}`),
      ]);

      return data;
    },

    async create(_, body) {
      const [{ data }] = await Promise.all([
        apiempresaweb.post('prevenda/app', body),
      ]);

      return data;
    },

    async update({ commit }, body) {
      const { data } = await apiempresaweb.put(`prevenda/app/${body.id}`, body);
      console.log('FALSE FINALIZAR');
      commit('SET_PREVENDA', { idcliente: body.prvidcliente });
      return data;
    },

    async delete(_, body) {
      const [{ data }] = await Promise.all([
        apiempresaweb.delete(`prevenda/app/${body.id}`, body),
      ]);

      return data;
    },
  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
    SET_PREVENDA(state, prevenda) {
      state.prevenda.idcliente = prevenda.idcliente ?? null;
      state.prevenda.nomecliente = prevenda.idcliente ? state.prevenda.nomecliente : null;
      // state.prevenda.idformapagto = prevenda.idformapagto ?? null;
    },
    SET_PREVENDA_QUANTIDADE(state, quantidade) {
      state.prevenda.quantidade = quantidade !== '0' ? quantidade : 0;
    },
    ADD_PREVENDA_QUANTIDADE(state, quantidade) {
      state.prevenda.quantidade = Number(state.prevenda.quantidade) + Number(quantidade);
    },
    DELETE_PREVENDA_QUANTIDADE(state, quantidade) {
      state.prevenda.quantidade -= quantidade;
    },
    SET_PREVENDA_NOMECLIENTE(state, nome) {
      state.prevenda.nomecliente = nome ?? null;
    },
    CLEAR_PREVENDA(state) {
      state.prevenda = {};
    },
    CLEAR_PREVENDA_CLIENTE(state) {
      state.prevenda.idcliente = null;
      state.prevenda.nomecliente = null;
    },
    SET_VALORTOTAL(state, valorTotal) {
      state.valorTotal = valorTotal ?? 0;
    },
    CLEAR_VALORTOTAL(state) {
      state.valorTotal = 0;
    },
  },
};
